import React from 'react';
import DogDisplayPage from './DogDisplayPage';
import { WidePhoto, TallPhoto } from './Constants';
import flower1 from './assets/images/flower/flower1.jpg';
import flower2 from './assets/images/flower/flower2.jpg';
import flower3 from './assets/images/flower/flower3.jpg';
import flower4 from './assets/images/flower/flower4.jpg';
import flower5 from './assets/images/flower/flower5.jpg';
import flower6 from './assets/images/flower/flower6.jpg';
import flower7 from './assets/images/flower/flower7.jpg';
import flower8 from './assets/images/flower/flower8.jpg';
import flower9 from './assets/images/flower/flower9.jpg';
import flower10 from './assets/images/flower/flower10.jpg';
import flower11 from './assets/images/flower/flower11.jpg';
import flower12 from './assets/images/flower/flower12.jpg';
import flower13 from './assets/images/flower/flower13.jpg';
import flower14 from './assets/images/flower/flower14.jpg';
import flower15 from './assets/images/flower/flower15.jpg';
import flower16 from './assets/images/flower/flower16.jpg';
import flower17 from './assets/images/flower/flower17.jpg';
import flower18 from './assets/images/flower/flower18.jpg';
import flower19 from './assets/images/flower/flower19.jpg';
import rainbow from './assets/images/rainbow.svg';

const photos = [
    { src: flower1, ...WidePhoto },
    { src: flower2, ...WidePhoto },
    { src: flower3, ...WidePhoto },
    { src: flower4, ...WidePhoto },
    { src: flower5, ...WidePhoto },
    { src: flower6, ...WidePhoto },
    { src: flower7, ...WidePhoto },
    { src: flower8, ...WidePhoto },
    { src: flower9, ...WidePhoto },
    { src: flower10, ...WidePhoto },
    { src: flower11, ...WidePhoto },
    { src: flower12, ...WidePhoto },
    { src: flower13, ...WidePhoto },
    { src: flower14, ...WidePhoto },
    { src: flower15, ...WidePhoto },
    { src: flower16, ...WidePhoto },
    { src: flower17, ...WidePhoto },
    { src: flower18, ...WidePhoto },
    { src: flower19, ...TallPhoto },
];
const Flower = () => {
    return (
        <DogDisplayPage photos={photos}>
            <h1 className="male">
                <span className="rainbow-dog">
                    <i className="far fa-venus"></i>
                    <img src={rainbow} alt="rainbow icon" className="rainbow-icon large" />
                    Flower
                </span>
            </h1>
            <table className="dog-chart">
                <tbody>
                    <tr>
                        <td><span className="title">Name</span>CH LUNANOVA MAIAS FLOR DA LAVANDA AWD CGN</td>
                        <td><span className="title">Owner</span>CAROLYNNE ISSA, LUNANOVA</td>
                        <td><span className="title">CKC Registration</span>#YS421680</td>
                    </tr>
                    <tr>
                        <td><span className="title">Sire</span>CH BIGBAY SELKIE'S WAGGISH MATE</td>
                        <td><span className="title">Dam</span>OLYMPUS GLICERIA MAIA ISSA</td>
                    </tr>
                    <tr>
                        <td><span className="title">Coat Type</span>CURLY</td>
                        <td><span className="title">Coat Colour</span>BLACK WITH WHITE MARKINGS</td>
                    </tr>
                    <tr>
                        <td><span className="title">OFA Hips</span>GOOD</td>
                        <td><span className="title">CERF</span>NORMAL</td>
                        <td><span className="title">Optigen PRA</span>normal</td>
                    </tr>
                    <tr>
                        <td><span className="title">Optigen IC</span>normal</td>
                        <td><span className="title">GM-1</span>normal</td>
                        <td><span className="title">JDCM</span>normal</td>
                    </tr>
                </tbody>
            </table>
        </DogDisplayPage>
    )
}
export default Flower;
